import { makeStyles } from "@material-ui/core";

const stylesCache = new WeakMap();

export const useStyles = (styles, props = {}) => {
  let hook = stylesCache.get(styles);
  if (!hook) {
    hook = makeStyles(styles);
    stylesCache.set(styles, hook);
  }
  return hook(props);
};

export default useStyles;
